<ng-container [ngSwitch]="mode">
  <ng-container
    *ngSwitchCase="LabelMode.DEFAULT"
    [ngTemplateOutlet]="default"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.INLINE"
    [ngTemplateOutlet]="inline"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.NO_LABEL"
    [ngTemplateOutlet]="input"
  ></ng-container>
</ng-container>

<ng-template #input>
  <ngb-timepicker
    [formControl]="form"
    [spinners]="spinners"
    class="{{ modeClass }} "
    [ngClass]="{ 'is-invalid': isError }"
  ></ngb-timepicker>
  <!-- <ngb-timepicker [name]="name" [formControl]="form" [spinners]="spinners" [class]="modeClass" [ngClass]="{ 'is-invalid': isError }"></ngb-timepicker> -->
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="{ 'is-invalid': isError }"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline" [ngClass]="classes">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="{ 'is-invalid': isError }"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #error>
  <span class="error" *ngIf="isError">{{ errorMessage | translate }}</span>
</ng-template>
